import { useMutation } from '@tanstack/react-query';

import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';

import {
  governanceIssuesFilterParams,
  type GovernanceIssuesFilters,
} from './useFetchGovernanceIssues';

/** Download every issue that matches the active Governance filters as CSV. */
export function useExportGovernanceIssues() {
  return useMutation({
    mutationFn: (filters: GovernanceIssuesFilters) =>
      fetchWrapper.get<Blob>(
        api.governanceIssuesExport,
        governanceIssuesFilterParams(filters),
      ),
  });
}
